const email = "hello@colinlarson.ca";
export const Colin = {
  name: "Colin Larson",
  email: email,
  mailto: "mailto:" + email,
  title: "Software Developer",
};
